import { Component, OnInit, QueryList } from '@angular/core';
import { ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router'

import { GraphSearchItemComponent } from '../graph-search-item/graph-search-item.component'
import { GraphSearchServiceService } from '../services/graph-search-service.service';


@Component({
  selector: 'app-graph-search',
  templateUrl: './graph-search.component.html',
  styleUrls: ['./graph-search.component.css']
})
export class GraphSearchComponent implements OnInit {

  constructor(
    private graphSearchService: GraphSearchServiceService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.url.subscribe(data =>{
      this.graph = data[0].path
    })
  }

  @ViewChildren(GraphSearchItemComponent) graphSearchItemComponetList: QueryList<GraphSearchItemComponent>
  

  graph;
  graphVisualData;


  searchGraph() {
    this.graphSearchItemComponetList.forEach(searchItem => searchItem.setValue())
    this.graphSearchService.getGraphVisualData(this.graph);
  }

  
}
